"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VoucherInfo = void 0;
var _mui = require("@ori-ui/mui");
var _jsxRuntime = require("react/jsx-runtime");
const Root = (0, _mui.styled)('div')(() => ({
  display: 'block'
}));
const VoucherInfo = ({
  discountDescription,
  pendingDiscountDescription
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)(Root, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
    fontWeight: "bold",
    children: discountDescription
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
    children: pendingDiscountDescription
  })]
});
exports.VoucherInfo = VoucherInfo;